function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVickyfineartClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2da88d5c-bea9-441c-a9f1-7f502175db0c",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.72 68.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "68.02 2.83 65.9 .71 34.36 32.24 2.83 .71 .71 2.83 32.24 34.36 .71 65.9 2.83 68.02 34.36 36.48 65.9 68.02 68.02 65.9 36.48 34.36 68.02 2.83",
    style: {
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVickyfineartClose);
export default __webpack_public_path__ + "static/media/vicky fineart - close.52275579e65971be9b891c434267c5dc.svg";
export { ForwardRef as ReactComponent };